import { techLogoPaths } from "@/components/TechChip";
import { sitePath } from "@/lib/site-path";

/** 固定の答えの名前の印 ({{Mac}} など) に置くロゴの住所。HP の技術の札 (TechChip) と同じ素材を使う */
export function womenFaqLogo(name: string): string[] {
  return techLogoPaths(name).map((path) => sitePath(path));
}
